import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React from 'react'

const TextDialogCompoent = ({open, setOpen, textInput, setTextInput, handleTextSubmit}) => {
  return (
		<Dialog open={open} onClose={() => setOpen(false)}>
			<DialogTitle>Enter Text</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					margin="dense"
					label="Text"
					type="text"
					fullWidth
					value={textInput}
					onChange={(e) => setTextInput(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpen(false)} color="primary">
					Cancel
				</Button>
				<Button onClick={handleTextSubmit} color="primary">
					Add Text
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default TextDialogCompoent